import { render, staticRenderFns } from "./sorunislem.vue?vue&type=template&id=4ba2633e&"
import script from "./sorunislem.vue?vue&type=script&lang=js&"
export * from "./sorunislem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports